import { render, staticRenderFns } from "./a-heading.vue?vue&type=template&id=6ca5802c&scoped=true&v-if=cms.heading"
import script from "./a-heading.vue?vue&type=script&lang=js"
export * from "./a-heading.vue?vue&type=script&lang=js"
import style0 from "./a-heading.vue?vue&type=style&index=0&id=6ca5802c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca5802c",
  null
  
)

export default component.exports